import { apiRoot } from '../apiInstances';
export type EntityKey = 'estimates' | 'work-orders' | 'invoices';
export const auditTrailApi = {
  list: async (entity: EntityKey, parentId: number) => {
    const { data } = await apiRoot.get(`/${entity}/${parentId}/audit-trail`);
    return data as any[];
  },
};
